require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-author-danielle-martin.json") })
        }
      }, "path---blog-author-danielle-martin");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-author-danielle-martin!./.cache/json/blog-author-danielle-martin.json
// module id = 627
// module chunks = 231608221292675